import { useQuery } from '@tanstack/react-query';
import type { CommissionResponse } from '@/shared/types';
import { CACHE_TIME_10_MINUTES, CACHE_TIME_5_MINUTES } from '@/shared/config';
import { getWithdrawCommission } from '@/features/withdraw-crypto';

interface UseWithdrawCommissionOptions {
  networkName: string;
  assetCode: string;
  amount: string | number;
  onTop?: boolean;
  enabled?: boolean;
  staleTime?: number;
  gcTime?: number;
}

export function useWithdrawCommission({
  networkName,
  assetCode,
  amount,
  onTop = false,
  enabled = true,
  staleTime = CACHE_TIME_5_MINUTES,
  gcTime = CACHE_TIME_10_MINUTES,
}: UseWithdrawCommissionOptions) {
  const queryKey = [
    'withdrawCommission',
    networkName,
    assetCode,
    amount,
    onTop,
  ];

  const query = useQuery<CommissionResponse, Error>({
    queryKey,
    queryFn: async () => {
      return await getWithdrawCommission(networkName, assetCode, amount, onTop);
    },
    enabled,
    staleTime,
    gcTime,
    retry: 0,
  });

  return {
    commissionData: query.data,
    isCommissionLoading: query.isLoading,
    isCommissionError: query.isError,
    commissionError: query.error,
    isCommissionFetching: query.isFetching,
    status: query.status,
    refetch: query.refetch,
    query,
  };
}
